import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {BringozArray} from "../persistence-layer/bringoz-array";
import {ContentTemplateModel} from "./models/content-template.model";

angular
  .module('bringoz.admin.content-templates')
  .factory('$contentTemplates', ContentTemplatesObjectFactory);

export type $contentTemplates = () => BringozArray<ContentTemplateModel>;


/* @ngInject */
function ContentTemplatesObjectFactory($bringozFactory: $bringozFactory,
                                       ContentTemplatesAPI: BringozApi,
                                       ContentTemplates_DS: DataStoreConfig) {

  function $contentTemplates(id: string) {
    return $bringozFactory(id, ContentTemplatesAPI, ContentTemplates_DS)
  }

  return $contentTemplates;
}
